// Library Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// Local Imports
import axios from "../../../network/https";
import { endPoints } from "../../../network/constant";

const initialState = {
  verificationSession: null,
  loading: false,
  error: null,
};

export const createVerificationSessionFunction = createAsyncThunk(
  "user/createVerificationSession",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.CreateVerificationSession);
      return data?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Reducers
export const verificationSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createVerificationSessionFunction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.verificationSession = null;
      })
      .addCase(createVerificationSessionFunction.fulfilled, (state, action) => {
        state.loading = false;
        state.verificationSession = action.payload;
        state.error = null;
      })
      .addCase(createVerificationSessionFunction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.verificationSession = null;
      });
  },
});

export default verificationSlice.reducer;
